import { render, staticRenderFns } from "./cardComponent.vue?vue&type=template&id=5d9b44bb"
import script from "./cardComponent.vue?vue&type=script&lang=js"
export * from "./cardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9b44bb')) {
      api.createRecord('5d9b44bb', component.options)
    } else {
      api.reload('5d9b44bb', component.options)
    }
    module.hot.accept("./cardComponent.vue?vue&type=template&id=5d9b44bb", function () {
      api.rerender('5d9b44bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardDinamic/cardComponent.vue"
export default component.exports